<template>
  <div
    :class="[
      'inno-property',
      {
        'vc-property--disabled': disabled,
      },
    ]"
  >
    <div class="inno-property__label">{{ label }}</div>
    <div class="inno-property__value">
      <slot>{{ value }}</slot>
    </div>
  </div>
</template>

<script setup lang="ts">
interface IProps {
  label: string;
  value?: string | number | boolean | null | undefined;
  disabled?: boolean;
}

defineProps<IProps>();
</script>

<style lang="scss">
.inno-property {
  --label-color: var(--vc-property-label-color, var(--color-neutral-700));
  --value-color: var(--vc-property-value-color, var(--color-neutral-950));

  &--disabled {
    --label-color: var(--color-neutral-500);
    --value-color: var(--color-neutral-500);
  }

  @apply grid grid-cols-2 md:grid-cols-[380px_1fr] items-end p-4;

  &__label {
    @apply min-w-0 truncate text-[--label-color];
  }

  &__dots {
    @apply mb-[3px] border-b border-dotted border-neutral-200;
  }

  &__value {
    @apply min-w-0 text-[--value-color] truncate;
  }
}
</style>
